import { useRef, useState, useEffect, useContext } from "react";
import styles from "./Chat.module.scss";
import {
  chatApi,
  Approaches,
  AskResponse,
  ChatRequest,
  ChatTurn,
  uploadDataChatApi,
} from "api";
import { Answer, AnswerError, AnswerLoading } from "components/OpenAIChat";
import { QuestionInput } from "components/OpenAIChat";
import { ExampleList } from "components/OpenAIChat";
import { UserChatMessage } from "components/OpenAIChat";
import { AnalysisPanel, AnalysisPanelTabs } from "components/OpenAIChat";
import { ClearChatButton } from "components/OpenAIChat";
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { UploadPanel } from "../UploadPanel/UploadPanel";
import { DemoContext } from "context/DemoContext";
import { SettingsContext } from "context";
import {
  CONTOSO_COPILOT_DEMOS,
  CONTOSO_COPILOT_PROD_HARDCODED,
  EDU_DEMO,
  PG_DEMO,
  GM_DEMO,
  getIndustry,
  MFG_FABRIC_DEMO,
} from "common";
import { useLocation } from "react-router-dom";

export const Chat = (props: any) => {
  const {
    config,
    setBackground,
    setEndpoint,
    setLogo,
    setPrompt1,
    setPrompt2,
    setPrompt3,
    setPlaceholderQuestion,
    setTitle,
  } = useContext(DemoContext);

  const location = useLocation();

  const { currentDemo, industry } = useContext(SettingsContext);

  const lastQuestionRef = useRef<string>("");
  const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<unknown>();

  const [activeCitation, setActiveCitation] = useState<string>();
  const [activeAnalysisPanelTab, setActiveAnalysisPanelTab] = useState<
    AnalysisPanelTabs | undefined
  >(undefined);

  const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
  const [answers, setAnswers] = useState<
    [user: string, response: AskResponse][]
  >([]);

  const [externalDomain, setExternalDomain] = useState(false);
  const [uploadToggle, setUploadToggle] = useState(false);

  const [fileUploadResponse, setFileUploadResponse] = useState<any>({});

  useEffect(
    function () {
      if (industry?.endPointURL) {
        setEndpoint(industry?.endPointURL);
      }
      lastQuestionRef.current = "";
      setAnswers([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [industry?.endPointURL]
  );

  const setPromptsTitleAndImages = () => {
    setBackground(
      // localStorage.getItem(`${currentDemo?.name}-background`) ??
      currentDemo?.backgroundImageURL
    );
    setLogo(
      // localStorage.getItem(`${currentDemo?.name}-logo`) ??
      currentDemo?.logoImageURL
    );
    setTitle(
      // localStorage.getItem(`${currentDemo?.name}-title`) ??
      currentDemo?.subTitle
    );
    setPrompt1(
      // localStorage.getItem(`${currentDemo?.name}-prompt1`) ??
      currentDemo?.prompt1
    );
    setPrompt2(
      // localStorage.getItem(`${currentDemo?.name}-prompt2`) ??
      currentDemo?.prompt2
    );
    setPrompt3(
      // localStorage.getItem(`${currentDemo?.name}-prompt3`) ??
      currentDemo?.prompt3
    );
    setPlaceholderQuestion(
      // localStorage.getItem(`${currentDemo?.name}-question`) ??
      currentDemo?.questionPlaceHolder
    );
  };

  useEffect(() => {
    setPromptsTitleAndImages();
    setUploadToggle(false);
    setExternalDomain(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDemo?.name]);

  const makeApiRequest = async (question: string) => {
    lastQuestionRef.current = question;
    error && setError(undefined);
    setIsLoading(true);
    setActiveCitation(undefined);
    setActiveAnalysisPanelTab(undefined);
    try {
      const history: ChatTurn[] = answers.map((a) => ({
        user: a[0],
        bot: a[1].answer,
      }));
      const request: ChatRequest = {
        history: [...history, { user: question, bot: undefined }],
        // ...(currentDemo?.chatApproach
        //   ? {
        //       approach: currentDemo.chatApproach,
        //     }
        //   : {
        //       approach: Approaches.ReadRetrieveRead,
        //     }),
        industry:
          currentDemo?.guid === MFG_FABRIC_DEMO
            ? "retail"
            : location.pathname.includes("/chat-bot-2")
            ? "retail"
            : currentDemo?.guid === "d2c57cac-ac43-4c5f-ad44-2c7f444376b9"
            ? "resai"
            : [
                ...CONTOSO_COPILOT_DEMOS,
                PG_DEMO,
                EDU_DEMO,
                "2f79c057-0be5-4374-98bd-0b424af0feee", // This is for the customer issue on clone of gm demo
              ].includes(currentDemo?.guid)
            ? "default" // NOTE: It was resai by default had to change it for video recording
            : currentDemo?.guid === GM_DEMO ||
              currentDemo.guid === MFG_FABRIC_DEMO
            ? "gm"
            : getIndustry(currentDemo.industryId),
        index:
          currentDemo.guid === MFG_FABRIC_DEMO
            ? "mfg-fabric-index-new"
            : location.pathname.includes("/chat-bot-2")
            ? "d7c54524"
            : currentDemo.indexName,
        container:
          currentDemo.guid === MFG_FABRIC_DEMO
            ? "mfg-fabric-container-new"
            : location.pathname.includes("/chat-bot-2")
            ? "d7c54524"
            : currentDemo.containerName,
        approach: Approaches.ReadRetrieveRead,
        overrides: {
          promptTemplate:
            config?.promptTemplate?.length === 0
              ? undefined
              : config?.promptTemplate,
          excludeCategory:
            config?.excludeCategory?.length === 0
              ? undefined
              : config?.excludeCategory,
          top: config?.retrieveCount,
          semanticRanker: config?.useSemanticRanker,
          semanticCaptions: config?.useSemanticCaptions,
          suggestFollowupQuestions: config?.useSuggestFollowupQuestions,
        },

        // ...(currentDemo?.chatCompany && { company: currentDemo?.chatCompany }),
        enableExternalDomain: externalDomain,
        guid: currentDemo?.guid,
      };
      if (industry) {
        const result = await chatApi(
          request,
          currentDemo?.guid === CONTOSO_COPILOT_PROD_HARDCODED &&
            externalDomain === false
            ? "https://func-search-chat-hardcoded.azurewebsites.net/api"
            : location.pathname.includes("/chat-bot-2")
            ? "https://func-openai-search-002.azurewebsites.net/api"
            : industry.endPointURL
        );
        setAnswers([...answers, [question, result]]);
      }
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const makeCustomUploadApiRequest = async (question: string) => {
    lastQuestionRef.current = question;
    error && setError(undefined);
    setIsLoading(true);
    setActiveCitation(undefined);
    setActiveAnalysisPanelTab(undefined);

    try {
      const history: ChatTurn[] = answers.map((a) => ({
        user: a[0],
        bot: a[1].answer,
      }));

      const request: ChatRequest = {
        history: [...history, { user: question, bot: undefined }],
        approach: Approaches.ReadRetrieveRead,
        overrides: {
          promptTemplate:
            config?.promptTemplate?.length === 0
              ? undefined
              : config?.promptTemplate,
          excludeCategory:
            config?.excludeCategory?.length === 0
              ? undefined
              : config?.excludeCategory,
          top: config?.retrieveCount,
          semanticRanker: config?.useSemanticRanker,
          semanticCaptions: config?.useSemanticCaptions,
          suggestFollowupQuestions: config?.useSuggestFollowupQuestions,
        },
        enableExternalDomain: externalDomain,
        container: fileUploadResponse.container_name,
        index: fileUploadResponse.index_name,
        guid: currentDemo?.guid,
      };
      if (industry) {
        const result = await uploadDataChatApi(request, industry.endPointURL);
        setAnswers([...answers, [question, result]]);
      }
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  const clearChat = () => {
    lastQuestionRef.current = "";
    error && setError(undefined);
    setActiveCitation(undefined);
    setActiveAnalysisPanelTab(undefined);
    setAnswers([]);
  };

  useEffect(
    () => chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" }),
    [isLoading]
  );

  useEffect(() => {
    setBackground(
      // localStorage.getItem(`${currentDemo?.name}-background`) ??
      currentDemo?.backgroundImageURL
    );
    return setLogo(
      // localStorage.getItem(`${currentDemo?.name}-logo`) ??
      currentDemo?.logoImageURL
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDemo]);

  useEffect(() => {
    if (props.isClearChat) {
      clearChat();
      setUploadToggle(false);
      setExternalDomain(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isClearChat]);

  const onExampleClicked = (example: string) => {
    makeApiRequest(example);
  };

  const onShowCitation = (citation: string, index: number) => {
    if (
      activeCitation === citation &&
      activeAnalysisPanelTab === AnalysisPanelTabs.CitationTab &&
      selectedAnswer === index
    ) {
      setActiveAnalysisPanelTab(undefined);
    } else {
      setActiveCitation(citation);
      setActiveAnalysisPanelTab(AnalysisPanelTabs.CitationTab);
    }

    setSelectedAnswer(index);
  };

  const onContextReady = (result: string) => {};

  const onToggleTab = (tab: AnalysisPanelTabs, index: number) => {
    if (activeAnalysisPanelTab === tab && selectedAnswer === index) {
      setActiveAnalysisPanelTab(undefined);
    } else {
      setActiveAnalysisPanelTab(tab);
    }

    setSelectedAnswer(index);
  };

  const onToggleExternalDomain = (event: SwitchChangeEvent) => {
    setExternalDomain(event.target.value);
  };

  const onToggleUploadButton = (event: SwitchChangeEvent) => {
    if (event.target.value) {
      setFileUploadResponse({});
    }
    setExternalDomain(false);
    setUploadToggle(event.target.value);
    clearChat();
  };
  const [copiedQuestion, setCopiedQuestion] = useState("");
  const [isReplay, setIsReplay] = useState(false);
  const onCopyMessage = (message: string) => {
    setCopiedQuestion(message);
  };

  return (
    <div className={styles.container}>
      <div className={styles.chatRoot}>
        <div className={styles.chatContainer}>
          <div
            className={styles.chatContainermanufacturingShadow}
            style={{
              paddingBottom: uploadToggle && lastQuestionRef.current ? 330 : 40,
            }}
          >
            {!lastQuestionRef.current ? (
              <div className={styles.chatEmptyState}>
                <img
                  src={config?.logo}
                  alt="logo"
                  className={styles.chatEmptyStateLogo}
                  style={{ marginBottom: !currentDemo?.disableTitle ? 0 : 16 }}
                />
                {!currentDemo?.disableTitle && (
                  <h1 className={styles.chatEmptyStateTitle}>
                    {currentDemo?.title}
                  </h1>
                )}
                <h2 className={styles.chatEmptyStateSubtitle}>
                  {currentDemo?.description}
                </h2>

                {!uploadToggle && (
                  <ExampleList
                    examples={[
                      {
                        text:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt1`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "What are the recommended approaches for optimizing sales forecasting?"
                            : currentDemo?.prompt1,
                        value:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt1`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "What are the recommended approaches for optimizing sales forecasting?"
                            : currentDemo?.prompt1,
                      },
                      {
                        text:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt2`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "How can I assess the carbon footprint of a product launch in the retail sector?"
                            : currentDemo?.prompt2,
                        value:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt2`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "How can I assess the carbon footprint of a product launch in the retail sector?"
                            : currentDemo?.prompt2,
                      },
                      {
                        text:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt3`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "Who should I include in integrated retail planning?"
                            : currentDemo?.prompt3,
                        value:
                          // localStorage.getItem(
                          //   `${currentDemo?.name}-prompt3`
                          // ) ??
                          location.pathname.includes("/chat-bot-2")
                            ? "Who should I include in integrated retail planning?"
                            : currentDemo?.prompt3,
                      },
                    ]}
                    onExampleClicked={onExampleClicked}
                  />
                )}
              </div>
            ) : (
              <div className={styles.chatMessageStream}>
                {answers.map((answer, index) => (
                  <div key={index}>
                    <UserChatMessage
                      message={answer[0]}
                      disabled={isLoading}
                      onCopyMessage={onCopyMessage}
                      setIsReplay={setIsReplay}
                    />
                    <div className={styles.chatMessageGpt}>
                      <Answer
                        key={index}
                        answer={answer[1]}
                        isSelected={
                          selectedAnswer === index &&
                          activeAnalysisPanelTab !== undefined
                        }
                        onCitationClicked={(c) => onShowCitation(c, index)}
                        onThoughtProcessClicked={() =>
                          onToggleTab(
                            AnalysisPanelTabs.ThoughtProcessTab,
                            index
                          )
                        }
                        onSupportingContentClicked={() =>
                          onToggleTab(
                            AnalysisPanelTabs.SupportingContentTab,
                            index
                          )
                        }
                        onFollowupQuestionClicked={(q) => makeApiRequest(q)}
                        showFollowupQuestions={
                          config?.useSuggestFollowupQuestions &&
                          answers?.length - 1 === index
                        }
                        endpoint={
                          currentDemo?.guid ===
                            CONTOSO_COPILOT_PROD_HARDCODED &&
                          externalDomain === false
                            ? "https://func-search-chat-hardcoded.azurewebsites.net/api"
                            : industry?.endPointURL!
                        }
                        container={
                          (uploadToggle &&
                            fileUploadResponse?.container_name) ||
                          (currentDemo.guid === MFG_FABRIC_DEMO
                            ? "mfg-fabric-container"
                            : currentDemo?.containerName)
                        }
                      />
                    </div>
                  </div>
                ))}
                {isLoading && (
                  <>
                    <UserChatMessage
                      message={lastQuestionRef.current}
                      disabled={isLoading}
                      onCopyMessage={onCopyMessage}
                      setIsReplay={setIsReplay}
                    />
                    <div className={styles.chatMessageGptMinWidth}>
                      <AnswerLoading />
                    </div>
                  </>
                )}
                {error ? (
                  <>
                    <UserChatMessage
                      message={lastQuestionRef.current}
                      disabled={isLoading}
                      onCopyMessage={onCopyMessage}
                      setIsReplay={setIsReplay}
                    />
                    <div className={styles.chatMessageGptMinWidth}>
                      <AnswerError
                        error={error.toString()}
                        onRetry={() => makeApiRequest(lastQuestionRef.current)}
                      />
                    </div>
                  </>
                ) : null}
                <div ref={chatMessageStreamEnd} />
              </div>
            )}
            {uploadToggle && (
              <UploadPanel
                hideExternalDropZone={lastQuestionRef.current}
                onContextReady={onContextReady}
                setFileUploadResponse={setFileUploadResponse}
                style={{
                  width: lastQuestionRef.current ? "92%" : "100%",
                  margin: "0 auto",
                  height: uploadToggle && lastQuestionRef.current && 350,
                  position:
                    uploadToggle && lastQuestionRef.current && "absolute",
                  bottom: uploadToggle && lastQuestionRef.current && 0,
                }}
                className={
                  uploadToggle &&
                  lastQuestionRef.current &&
                  styles.uploadDuringChat
                }
              />
            )}

            <div className={styles.chatInput}>
              <QuestionInput
                copiedQuestion={copiedQuestion}
                setCopiedQuestion={setCopiedQuestion}
                isReplay={isReplay}
                setIsReplay={setIsReplay}
                clearOnSend
                placeholder={config?.placeholderQuestion}
                disabled={isLoading}
                onSend={(question) =>
                  uploadToggle
                    ? makeCustomUploadApiRequest(question)
                    : makeApiRequest(question)
                }
              />
              <div className={styles.chatInputFooter}>
                <div>
                  <div className={styles.chatInputToggle}>
                    <label>
                      Pre-trained knowledge{" "}
                      <Switch
                        onChange={onToggleExternalDomain}
                        checked={externalDomain}
                      />
                    </label>
                    <label>
                      Try your own data{" "}
                      <Switch
                        onChange={onToggleUploadButton}
                        checked={uploadToggle}
                      />
                    </label>
                  </div>
                </div>
                <ClearChatButton
                  className={styles.clearChatButton}
                  onClick={clearChat}
                  disabled={!lastQuestionRef.current || isLoading}
                />
              </div>
            </div>
          </div>
        </div>

        {answers?.length > 0 && activeAnalysisPanelTab && (
          <AnalysisPanel
            className={styles.chatAnalysisPanel}
            activeCitation={activeCitation}
            onActiveTabChanged={(x) => onToggleTab(x, selectedAnswer)}
            citationHeight="810px"
            answer={answers[selectedAnswer][1]}
            activeTab={activeAnalysisPanelTab}
          />
        )}
      </div>
    </div>
  );
};
